import { Dispatch } from "react";
import { IActionType } from "../../interfaces/Index";
import * as actionTypes from "../actionTypes/Index";
import {
  ICreditLimitResponse,
  ICreditPaymentPlansResponse,
  ICreditUserStatusResponse,
} from "interfaces/credit.interface";
import {
  fetchCreditPaymentPlansCall,
  fetchCreditUserCall,
  fetchUserCreditLimitCall,
} from "redux/sources/CreditSource";

export const getUserCreditLimitInit = () => ({
  type: actionTypes.GET_USERS_CREDIT_LIMIT_INIT,
});

export const getUserCreditLimitSuccess = (payload: ICreditLimitResponse) => ({
  type: actionTypes.GET_USERS_CREDIT_LIMIT_SUCCESS,
  payload,
});

export const fetchCreditUserInit = () => ({
  type: actionTypes.FETCH_CREDIT_USER_INIT,
});

export const fetchCreditUserSuccess = (payload: ICreditUserStatusResponse) => ({
  type: actionTypes.FETCH_CREDIT_USER_SUCCESS,
  payload,
});

export const fetchCreditUserFail = (error: string | object | null) => ({
  type: actionTypes.FETCH_CREDIT_USER_FAIL,
  error,
});

export const getUserCreditLimitFail = (error: string | object | null) => ({
  type: actionTypes.GET_USERS_CREDIT_LIMIT_FAIL,
  error,
});

export const getCreditPaymentPlansInit = () => ({
  type: actionTypes.GET_CREDIT_PAYMENT_PLANS_INIT,
});

export const getCreditPaymentPlansSuccess = (
  payload: ICreditPaymentPlansResponse[]
) => ({
  type: actionTypes.GET_CREDIT_PAYMENT_PLANS_SUCCESS,
  payload,
});

export const getCreditPaymentPlansFail = (error: string | object | null) => ({
  type: actionTypes.GET_CREDIT_PAYMENT_PLANS_FAIL,
  error,
});

export const clearCreditPlansAndUserLimit = () => ({
  type: actionTypes.CLEAR_CREDIT_LIMIT_AND_PLANS,
});

// async actions
export const fetchUserCreditLimit =
  (userId: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getUserCreditLimitInit());
    return fetchUserCreditLimitCall(userId)
      .then((limit: ICreditLimitResponse) =>
        dispatch(getUserCreditLimitSuccess(limit))
      )
      .catch((e: object | null | string) =>
        dispatch(getUserCreditLimitFail(e))
      );
  };

export const fetchCreditUser =
  (userId: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchCreditUserInit());
    return fetchCreditUserCall(userId)
      .then((status: ICreditUserStatusResponse) =>
        dispatch(fetchCreditUserSuccess(status))
      )
      .catch((e: object | null | string) => dispatch(fetchCreditUserFail(e)));
  };

export const fetchCreditPaymentPlans =
  (channelType: string, userId: string) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(getCreditPaymentPlansInit());
    return fetchCreditPaymentPlansCall(channelType, userId)
      .then((paymentPlans: ICreditPaymentPlansResponse[]) =>
        dispatch(getCreditPaymentPlansSuccess(paymentPlans))
      )
      .catch((e: object | null | string) =>
        dispatch(getCreditPaymentPlansFail(e))
      );
  };

export const clearCreditLimitAndPlansAction =
  () => (dispatch: Dispatch<IActionType>) => {
    return dispatch(clearCreditPlansAndUserLimit());
  };
